import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import styles from './index.css';
import publicStyle from '../public/newsGroup.css';
import { classnames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';

class HeadlinePhotoNews extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
    };

    getImageUrl(item) {
        if ('picUrl' in item) return item.picUrl;
        else return item.url;
    }
    listView(list = []) {
        return list.map((item, index) => {
            const key = item.id;
            const url = item.notFormatUrl ? item.url : formatUrl(item.url);
            const { image } = item.thumbnails;

            if (index === 0) {
                return (
                    <li key={key} className={styles.bigImage}>
                        <a href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={image ? formatImage(this.getImageUrl(image[0]), 300, 200) : undefined}
                                alt={item.title}
                                width={300}
                                height={200}
                            />
                            <p className={styles.bigImageTitle}>{item.title}</p>
                        </a>
                    </li>
                );
            } else {
                return (
                    <li key={key} className={`${styles.has_image} clearfix`}>
                        <a className={styles.image_link} href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={image ? formatImage(this.getImageUrl(image[0]), 98, 54) : undefined}
                                alt={item.title}
                                width={98}
                                height={54}
                            />
                        </a>
                        <div>
                            <h5 className={styles.image_title}>
                                <a href={url} title={item.title} target="_blank" rel={relText}>
                                    {item.title}
                                </a>
                            </h5>
                            <time className={styles.time}>{item.newsTime}</time>
                        </div>
                    </li>
                );
            }
        });
    }
    render() {
        const {
            content,
            componentOptions: { infoTitle, infoUrl },
        } = this.props;

        return (
            <div className={publicStyle.news_group}>
                {/* 标题 */}
                <div className={`${publicStyle.news_group_title} clearfix`}>
                    <i className={classnames(publicStyle.block, 'block')} />
                    <span className={publicStyle.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={publicStyle.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                </div>
                <ul className={styles.news_list}>{this.listView(content)}</ul>
            </div>
        );
    }
}

export default errorBoundary(HeadlinePhotoNews);
